import { render, staticRenderFns } from "./addUpdHoor.vue?vue&type=template&id=646acf14&scoped=true"
import script from "./addUpdHoor.vue?vue&type=script&lang=js"
export * from "./addUpdHoor.vue?vue&type=script&lang=js"
import style0 from "./addUpdHoor.vue?vue&type=style&index=0&id=646acf14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646acf14",
  null
  
)

export default component.exports